import { RoutePrefix } from '#/routing/classes/RoutePrefix';

export const salariesPrefix = new RoutePrefix('/nonprofit-salary-explorer');

export const salariesSurveyPath = salariesPrefix.path('survey', ['step']);

export const salariesFaqPath = salariesPrefix.path('faq');

export const salariesLearnMorePath = salariesPrefix.path('learn-more');

export const salariesExplorePath = salariesPrefix.path('explore', [
  'exploreTmpId',
]);
